/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A request to cancel a direct booking
 * @export
 * @interface DirectBookingCancelRequest
 */
export interface DirectBookingCancelRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DirectBookingCancelRequest
     */
    test?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DirectBookingCancelRequest
     */
    hotelStayId?: string;
    /**
     * 
     * @type {number}
     * @memberof DirectBookingCancelRequest
     */
    bookingId?: number;
    /**
     * 
     * @type {number}
     * @memberof DirectBookingCancelRequest
     */
    vervotechPropertyId?: number;
    /**
     * 
     * @type {string}
     * @memberof DirectBookingCancelRequest
     */
    confirmationNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof DirectBookingCancelRequest
     */
    checkinDate: Date;
    /**
     * 
     * @type {string}
     * @memberof DirectBookingCancelRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof DirectBookingCancelRequest
     */
    lastName: string;
    /**
     * 
     * @type {boolean}
     * @memberof DirectBookingCancelRequest
     */
    rateUpdate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DirectBookingCancelRequest
     */
    taskId?: string;
}

/**
 * Check if a given object implements the DirectBookingCancelRequest interface.
 */
export function instanceOfDirectBookingCancelRequest(value: object): value is DirectBookingCancelRequest {
    if (!('confirmationNumber' in value) || value['confirmationNumber'] === undefined) return false;
    if (!('checkinDate' in value) || value['checkinDate'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function DirectBookingCancelRequestFromJSON(json: any): DirectBookingCancelRequest {
    return DirectBookingCancelRequestFromJSONTyped(json, false);
}

export function DirectBookingCancelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectBookingCancelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'test': json['test'] == null ? undefined : json['test'],
        'hotelStayId': json['hotel_stay_id'] == null ? undefined : json['hotel_stay_id'],
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'vervotechPropertyId': json['vervotech_property_id'] == null ? undefined : json['vervotech_property_id'],
        'confirmationNumber': json['confirmation_number'],
        'checkinDate': (new Date(json['checkin_date'])),
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'rateUpdate': json['rate_update'] == null ? undefined : json['rate_update'],
        'taskId': json['task_id'] == null ? undefined : json['task_id'],
    };
}

export function DirectBookingCancelRequestToJSON(value?: DirectBookingCancelRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'test': value['test'],
        'hotel_stay_id': value['hotelStayId'],
        'booking_id': value['bookingId'],
        'vervotech_property_id': value['vervotechPropertyId'],
        'confirmation_number': value['confirmationNumber'],
        'checkin_date': ((value['checkinDate']).toISOString().substring(0,10)),
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'rate_update': value['rateUpdate'],
        'task_id': value['taskId'],
    };
}

